export const SET_SELECTED_GROUP_MODEL = 'PROFILE/RISK_TOLERANCE/SET_SELECTED_GROUP_MODEL';

export const setSelectedGroupModel = (selectedGroupId, selectedModelId) => ({
  type: SET_SELECTED_GROUP_MODEL,
  payload: { selectedGroupId, selectedModelId },
});
